import { Reducer } from 'react';
import { handleActions } from 'redux-actions';
import {
    ACTION_CREATESTORE_SUCCESS,
    ACTION_UPDATESTORE_SUCCESS,
    ACTION_GETSTORELIST_SUCCESS,
    ACTION_OPERATESTORE_FAIL,
    ACTION_DELETESTORE_SUCCESS,
} from '../../actions/silizhu/store'

export interface silizhuStoreState {
    storeList: any,
    isSuccess: boolean,
    failData: string,
    operationList: any[]
}

const defaultState: silizhuStoreState = {
    storeList: {},
    isSuccess: false,
    failData: '',
    operationList: []
}

function handleActionGetStoreListSuccess(state: silizhuStoreState, action): silizhuStoreState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        storeList: action.payload.storeList,
        operationList: action.payload.operationList
    }
}

function handleActionUpdateStoreSucces(state: silizhuStoreState, action): silizhuStoreState {
    console.log(`ACTION: ${action.type}`);
    return {
        ...state,
        isSuccess: true,
        failData: ''
    }
}

function handleActionCreateStoreSuccess(state: silizhuStoreState, action): silizhuStoreState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        isSuccess: true,
        failData: ''
    }
}

function handleActionOperateStoreFail(state: silizhuStoreState, action): silizhuStoreState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        isSuccess: false,
        failData: action.payload.data
    }
}

function handleActionDeleteStoreSuccess(state: silizhuStoreState, action): silizhuStoreState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
    }
}

export const silizhuStoreReducer: Reducer<silizhuStoreState, any> = handleActions(
    {
        [ACTION_GETSTORELIST_SUCCESS]: handleActionGetStoreListSuccess,
        [ACTION_CREATESTORE_SUCCESS]: handleActionCreateStoreSuccess,
        [ACTION_OPERATESTORE_FAIL]: handleActionOperateStoreFail,
        [ACTION_UPDATESTORE_SUCCESS]: handleActionUpdateStoreSucces,
        [ACTION_DELETESTORE_SUCCESS]: handleActionDeleteStoreSuccess,
    },
    defaultState
)